import { useConversations } from "../contexts/ConversationsProvider";
import Ship from "./Ship";

function ShipList({ ships }) {
  const { conversations } = useConversations();
  //console.log("SHIPS:", ships);
  return (
    <>
      {ships === null || ships === undefined ? (
        <div>No Ships Nearby</div>
      ) : (
        ships.map((ship) => (
          <Ship
            key={ship.mmsi != null ? ship.mmsi : ship.id}
            ship={ship}
            shipName={
              conversations[ship.mmsi != null ? ship.mmsi : ship.id] != null
                ? conversations[ship.mmsi != null ? ship.mmsi : ship.id]
                    .shipName
                : null
            }
            hasMessages={
              conversations[ship.mmsi != null ? ship.mmsi : ship.id] != null &&
              conversations[ship.mmsi != null ? ship.mmsi : ship.id].messages !=
                null &&
              conversations[ship.mmsi != null ? ship.mmsi : ship.id].messages
                .length > 0
            }
            unreadMessages={
              conversations[ship.mmsi != null ? ship.mmsi : ship.id] != null &&
              conversations[ship.mmsi != null ? ship.mmsi : ship.id]
                .unreadMessages != null
                ? conversations[ship.mmsi != null ? ship.mmsi : ship.id]
                    .unreadMessages
                : 0
            }
          />
        ))
      )}
    </>
  );
}

export default ShipList;
